// extracted by mini-css-extract-plugin
export default {"container":"ChoiceColor_container__GSjbT"};